import React, { useState } from 'react';

import { useI18n } from 'Hooks';
import { filterLanguages } from 'utils/langText';

import flagES from '../../../assets/images/Flags/es.svg';
import flagEN from '../../../assets/images/Flags/gb.svg';
import globe from '../../../assets/images/Flags/globe.svg';
import flagNO from '../../../assets/images/Flags/no.svg';
import flagSE from '../../../assets/images/Flags/se.svg';
import TextInput from '../../../Components-redesign/Fields/TextInput';

export const languageIcons = {
  se: flagSE,
  en: flagEN,
  es: flagES,
  no: flagNO,
};

export interface Props {
  languages: string[];
  name: string;
  placeholder?: { se?: string; en?: string; es?: string } | undefined;
  value: any;
  handleChange: (name, value, lang) => void;
}

const LangInputFields: React.FC<Props> = ({
  languages,
  name,
  placeholder,
  value,
  handleChange,
}) => {
  const [emptyFields, setEmptyFields] = useState<string[]>([]);
  const { t } = useI18n();

  const handleBlur = () => {
    setEmptyFields(() => {
      if (!value) {
        return languages;
      } else {
        return languages.filter((lang) => {
          return !value[lang] || value[lang].length < 1;
        });
      }
    });
  };

  const getLanguageIcon = (lang) => {
    const baseLanguages = ['se', 'en', 'es', 'no'];

    const companyHasNewLanguages = languages.some((language) => !baseLanguages.includes(language));

    if (lang === 'se') {
      return companyHasNewLanguages ? globe : flagSE;
    }
    return languageIcons[lang];
  };

  return (
    <div>
      {filterLanguages(languages).map((lang) => {
        const val = value ? value[lang] : '';

        return (
          <TextInput
            onBlur={handleBlur}
            key={lang}
            style={
              emptyFields.find((field) => field == lang)
                ? { borderColor: 'var(--colorUIRed)', backgroundColor: 'var(--colorWhite)' }
                : { backgroundColor: 'var(--colorWhite)' }
            }
            name={name}
            placeHolder={placeholder ? placeholder[lang] : t('General.EnterText')}
            value={val ?? ''}
            handleChange={(e) => handleChange(e.target.name, e.target.value, lang)}>
            {languages.length > 1 && <img src={getLanguageIcon(lang)} />}
          </TextInput>
        );
      })}
    </div>
  );
};

export default LangInputFields;
